var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{style:('border-radius:5px 0 0 0;height:' + (_vm.height ? _vm.height : '100') + 'px;background-color:' + _vm.primaryColor),attrs:{"cols":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }